export const REQUEST_IDLE = "requestIdle";
export const REQUEST_CALLED = "requestCalled";
export const REQUEST_ERROR = "requestError";
export const REQUEST_SUCCESS = "requestSuccess";
